import styled, { css } from "styled-components";
import percentToHex from "../utils/hexOpacity";
import color from "../_style/color";

const Tag = styled.div`
  margin: 0;
  padding: 0;

  height: 20px;
  width: 20px;

  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  background: ${color.chardonnay + percentToHex(10)};
  border: 1px solid ${color.yellowSea};
  border-radius: 4px;

  cursor: pointer;

  color: ${color.yellowSea};
  font-weight: bold;
  font-size: 12px;
  line-height: 20px;

  box-sizing: border-box;

  ${({ isSmall }) =>
    isSmall &&
    css`
      height: 12px;
      width: 12px;
      font-size: 10px;
    `}

  ${({ isUma }) =>
    isUma &&
    css`
      min-width: 38px;
      height: 20px;
    `}
`;

export default Tag;
